import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  Alert,
} from "reactstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faUser,
  faLock,
  faTrash,
  faEnvelope,
  faTimes,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  updateProfile,
  changePassword,
  deleteAccount,
  logoutJWT,
} from "../redux/authJWT/action";
import AccountSidebar from "../components/AccountSidebar/AccountSidebar";
import PasswordInput from "../components/common/PasswordInput";
import PasswordCriteria from "../components/common/PasswordCriteria";
import { isPasswordValid } from "../util/passwordValidation";
import { isAppSession } from "../helper/nativeBridge";
import { language } from "../languageProvider/language/language";
import { defaultLanguage } from "../helper/utility";
import "./Profile.page.css";

function ProfilePage(props) {
  const navigate = useNavigate();
  const { user } = props.authJWT;


  const [profileForm, setProfileForm] = useState({
    name: user?.name || "",
    surname: user?.surname || "",
    email: user?.email || "",
  });
  const [profileSuccess, setProfileSuccess] = useState(false);
  const appSession = isAppSession();
  const [isEditing, setIsEditing] = useState(false);

  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordError, setPasswordError] = useState(null);
  const [passwordSuccess, setPasswordSuccess] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleProfileChange = (e) => {
    setProfileForm({ ...profileForm, [e.target.name]: e.target.value });
    setProfileSuccess(false);
  };

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    props.updateProfile(profileForm);
    setProfileSuccess(true);
    setIsEditing(false);
    setTimeout(() => setProfileSuccess(false), 3000);
  };

  const handleCancelEdit = () => {
    setProfileForm({
      name: user?.name || "",
      surname: user?.surname || "",
      email: user?.email || "",
    });
    setIsEditing(false);
    setProfileSuccess(false);
  };

  const handlePasswordChange = (e) => {
    setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value });
    setPasswordError(null);
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (!isPasswordValid(passwordForm.newPassword)) {
      setPasswordError(language[defaultLanguage].password_min_length);
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordError(language[defaultLanguage].password_non_corrispondono);
      return;
    }
    props.changePassword({ password: passwordForm.newPassword });
    setPasswordSuccess(true);
    setTimeout(() => {
      setPasswordModalOpen(false);
      setPasswordSuccess(false);
      setPasswordForm({ newPassword: "", confirmPassword: "" });
    }, 2000);
  };

  const handleDeleteAccount = () => {
    setDeleteModalOpen(false);
    props.deleteAccount(navigate);
  };

  const handleLogout = () => {
    props.logoutJWT(navigate);
  };

  const initials =
    (user?.name ? user.name[0] : "").toUpperCase() +
    (user?.surname ? user.surname[0] : "").toUpperCase();

  return (
    <div className="up-page">
      {/* Top bar */}
      <div className="up-topbar">
        <div className="up-topbar__left">
          <div className="up-topbar__back" onClick={() => navigate("/leaflet")}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
          <h1 className="up-topbar__title">{language[defaultLanguage].profilo}</h1>
        </div>
      </div>

      <div className="up-layout">
        <AccountSidebar />

        <div className="up-main">
          {/* User card header */}
          <div className="up-card up-card--user">
            <div className="up-user">
              <div className="up-user__avatar">{initials}</div>
              <div className="up-user__info">
                <div className="up-user__name">{user?.name} {user?.surname}</div>
                <div className="up-user__email">
                  <FontAwesomeIcon icon={faEnvelope} className="up-user__email-icon" />
                  {user?.email}
                </div>
              </div>
            </div>
          </div>

          {/* Profile form card */}
          <div className="up-card">
            <div className="up-card__header">
              <div className="up-card__header-left">
                <FontAwesomeIcon icon={faUser} className="up-card__icon" />
                <h2 className="up-card__title">{language[defaultLanguage].modifica_profilo}</h2>
              </div>
              {!isEditing && !appSession && (
                <button
                  className="up-btn up-btn--outline"
                  onClick={() => setIsEditing(true)}
                >
                  Modifica
                </button>
              )}
            </div>

            {profileSuccess && (
              <Alert color="success" className="py-2 mb-3">
                {language[defaultLanguage].profilo_aggiornato_successo}
              </Alert>
            )}

            <form onSubmit={handleProfileSubmit}>
              <div className="up-form__row">
                <div className="up-form__group">
                  <label className="up-form__label">{language[defaultLanguage].nome}</label>
                  <input
                    name="name"
                    type="text"
                    className="up-form__input"
                    value={profileForm.name}
                    onChange={handleProfileChange}
                    disabled={!isEditing}
                    required
                    minLength={2}
                  />
                </div>
                <div className="up-form__group">
                  <label className="up-form__label">{language[defaultLanguage].cognome}</label>
                  <input
                    name="surname"
                    type="text"
                    className="up-form__input"
                    value={profileForm.surname}
                    onChange={handleProfileChange}
                    disabled={!isEditing}
                    required
                    minLength={2}
                  />
                </div>
              </div>
              <div className="up-form__group">
                <label className="up-form__label">{language[defaultLanguage].email}</label>
                <input
                  name="email"
                  type="email"
                  className="up-form__input"
                  value={profileForm.email}
                  onChange={handleProfileChange}
                  disabled={!isEditing}
                  required
                />
              </div>

              {isEditing && (
                <div className="up-card__actions">
                  <button type="submit" className="up-btn up-btn--primary">
                    {language[defaultLanguage].salva_modifiche}
                  </button>
                  <button
                    type="button"
                    className="up-btn up-btn--ghost"
                    onClick={handleCancelEdit}
                  >
                    {language[defaultLanguage].annulla}
                  </button>
                </div>
              )}
            </form>
          </div>

          {/* In app password, account e logout li gestisce l'app */}
          {!appSession && (<>
          {/* Password card */}
          <div className="up-card">
            <div className="up-card__header">
              <div className="up-card__header-left">
                <FontAwesomeIcon icon={faLock} className="up-card__icon" />
                <h2 className="up-card__title">{language[defaultLanguage].cambia_password}</h2>
              </div>
              <button
                className="up-btn up-btn--outline"
                onClick={() => {
                  setPasswordModalOpen(true);
                  setPasswordSuccess(false);
                  setPasswordError(null);
                  setPasswordForm({ newPassword: "", confirmPassword: "" });
                }}
              >
                {language[defaultLanguage].cambia_password}
              </button>
            </div>
          </div>

          {/* Delete account card */}
          <div className="up-card up-card--danger">
            <div className="up-card__header">
              <div className="up-card__header-left">
                <FontAwesomeIcon icon={faTrash} className="up-card__icon up-card__icon--danger" />
                <h2 className="up-card__title up-card__title--danger">{language[defaultLanguage].elimina_account}</h2>
              </div>
              <button
                className="up-btn up-btn--danger-outline"
                onClick={() => setDeleteModalOpen(true)}
              >
                {language[defaultLanguage].elimina_account}
              </button>
            </div>
          </div>

          {/* Logout card */}
          <div className="up-card">
            <div className="up-card__header">
              <div className="up-card__header-left">
                <FontAwesomeIcon icon={faSignOutAlt} className="up-card__icon" />
                <h2 className="up-card__title">{language[defaultLanguage].logout || "Esci"}</h2>
              </div>
              <button className="up-btn up-btn--outline" onClick={handleLogout}>
                {language[defaultLanguage].logout || "Esci"}
              </button>
            </div>
          </div>
          </>)}
        </div>
      </div>

      {/* Change Password Modal */}
      <Modal
        isOpen={passwordModalOpen}
        toggle={() => setPasswordModalOpen(false)}
        centered
        className="up-modal--sm"
      >
        <ModalBody className="up-modal__body">
          <div className="up-modal__header">
            <h3 className="up-modal__title">{language[defaultLanguage].cambia_password}</h3>
            <div className="up-modal__close" onClick={() => setPasswordModalOpen(false)}>
              <FontAwesomeIcon icon={faTimes} />
            </div>
          </div>

          {passwordSuccess ? (
            <Alert color="success">
              {language[defaultLanguage].password_cambiata_successo}
            </Alert>
          ) : (
            <form onSubmit={handlePasswordSubmit}>
              <div className="up-form__group">
                <label className="up-form__label">{language[defaultLanguage].nuova_password}</label>
                <PasswordInput
                  value={passwordForm.newPassword}
                  id="newPassword"
                  name="newPassword"
                  placeholder={language[defaultLanguage].nuova_password}
                  required
                  onChange={handlePasswordChange}
                />
                <PasswordCriteria password={passwordForm.newPassword} />
              </div>
              <div className="up-form__group">
                <label className="up-form__label">{language[defaultLanguage].conferma_nuova_password}</label>
                <PasswordInput
                  value={passwordForm.confirmPassword}
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder={language[defaultLanguage].conferma_nuova_password}
                  required
                  onChange={handlePasswordChange}
                />
              </div>
              {passwordError && (
                <Alert color="danger" className="py-2 mt-2">
                  {passwordError}
                </Alert>
              )}
              <button type="submit" className="up-btn up-btn--primary up-btn--full" style={{ marginTop: "16px" }}>
                {language[defaultLanguage].salva_modifiche}
              </button>
            </form>
          )}
        </ModalBody>
      </Modal>

      {/* Delete Account Modal */}
      <Modal
        isOpen={deleteModalOpen}
        toggle={() => setDeleteModalOpen(false)}
        centered
        className="up-modal--sm"
      >
        <ModalBody className="up-modal__body">
          <div className="up-modal__header">
            <h3 className="up-modal__title">{language[defaultLanguage].elimina_account}</h3>
            <div className="up-modal__close" onClick={() => setDeleteModalOpen(false)}>
              <FontAwesomeIcon icon={faTimes} />
            </div>
          </div>
          <p className="up-modal__text">{language[defaultLanguage].conferma_eliminazione}</p>
          <div className="up-modal__footer">
            <button className="up-btn up-btn--ghost" onClick={() => setDeleteModalOpen(false)}>
              {language[defaultLanguage].annulla}
            </button>
            <button className="up-btn up-btn--danger" onClick={handleDeleteAccount}>
              {language[defaultLanguage].conferma}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => ({
  authJWT: state.authJWT,
});

export default connect(mapStateToProps, {
  updateProfile,
  changePassword,
  deleteAccount,
  logoutJWT,
})(ProfilePage);
